import type * as Types from 'app/types/graphql';

export type SubscriptionEdgeSelectFragment = {
  edges?: Types.Maybe<
    Array<{
      node?: Types.Maybe<
        Pick<
          Types.Subscription,
          'id' | 'amount' | 'cappedAmount' | 'planID' | 'shopPlatformID' | 'unit'
        >
      >;
    }>
  >;
};

export type SubscriptionSelectFragment = Pick<
  Types.Subscription,
  'id' | 'amount' | 'cappedAmount' | 'planID' | 'shopPlatformID' | 'unit'
>;

export const SubscriptionSelectFragmentDoc = `
    fragment SubscriptionSelect on Subscription {
  id
  amount
  cappedAmount
  planID
  shopPlatformID
  unit
}
    `;
export const SubscriptionEdgeSelectFragmentDoc = `
    fragment SubscriptionEdgeSelect on SubscriptionConnection {
  edges {
    node {
      ...SubscriptionSelect
    }
  }
}
    `;
